import { Box } from '@mui/material'
import BlockUserActionButton from './BlockUserActionButton'
import { IUser } from 'types/models/User'
import CheckIconButton from 'components/icons/ApproveTeamRequestActionButton';
import CloseIconButton from 'components/icons/RejectTeamRequestActionButton';
import ApproveTeamRequestActionButton from 'components/icons/ApproveTeamRequestActionButton';
import RejectTeamRequestActionButton from 'components/icons/RejectTeamRequestActionButton';

interface Props {
    id: string;
    refetch?: () => void;
}

export default function TeamRequestActions(props: Props) {
    return (
        <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            gap={1}
        >
            <ApproveTeamRequestActionButton {...props} />
            <RejectTeamRequestActionButton {...props} />

        </Box>
    )
}
